import React, { useState, useRef, useEffect } from "react";
import { Send, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const QUICK_PHRASES = ["GG!", "Nice!", "On my way!", "Watch out!", "Let's go!", "Need backup!", "Sorry!", "Well played!"];
export const EMOTES = ["👍", "🔥", "😂", "😮", "🎉", "❤️", "😎", "💀"];

export function CoopChat({ chat = [], onSend, meId }) {
  const [msg, setMsg] = useState("");
  const feedRef = useRef(null);
  useEffect(() => { if (feedRef.current) feedRef.current.scrollTop = feedRef.current.scrollHeight; }, [chat.length]);

  const submit = (e) => { e.preventDefault(); const b = msg.trim(); if (!b) return; setMsg(""); onSend(b, "text"); };

  return (
    <div className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-5" data-testid="coop-chat">
      <h3 className="font-display font-bold mb-2 flex items-center gap-2"><MessageSquare className="w-5 h-5 text-[hsl(var(--primary))]" /> Quick chat</h3>
      <div ref={feedRef} className="space-y-1.5 overflow-y-auto max-h-40 mb-3 pr-1" data-testid="coop-chat-feed">
        {chat.length === 0 ? (
          <p className="text-sm text-[hsl(var(--muted-foreground))] py-2 text-center">Say something to your squad 👋</p>
        ) : chat.map((c) => (
          <div key={c.id} className="text-sm leading-snug" data-testid={`coop-chat-msg-${c.id}`}>
            <span className="font-semibold">{c.avatar} {c.name}{c.user_id === meId ? " (you)" : ""}:</span>{" "}
            <span className={c.kind === "emote" ? "text-xl align-middle" : "text-[hsl(var(--muted-foreground))]"}>{c.body}</span>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5 mb-2" data-testid="coop-quick-phrases">
        {QUICK_PHRASES.map((p, i) => (
          <button key={p} type="button" onClick={() => onSend(p, "quick")} data-testid={`quick-phrase-${i}`}
            className="px-2.5 py-1 rounded-full text-xs font-medium border border-[hsl(var(--border))] hover:border-[hsl(var(--primary))]/60 hover:bg-[hsl(var(--accent))] transition-colors">{p}</button>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5 mb-3" data-testid="coop-emotes">
        {EMOTES.map((e, i) => (
          <button key={e} type="button" onClick={() => onSend(e, "emote")} data-testid={`emote-${i}`}
            className="w-8 h-8 grid place-items-center rounded-lg text-lg border border-[hsl(var(--border))] hover:bg-[hsl(var(--accent))] hover:scale-110 transition-transform">{e}</button>
        ))}
      </div>
      <form onSubmit={submit} className="flex gap-2">
        <Input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Message…" maxLength={500} data-testid="coop-chat-input" />
        <Button type="submit" size="icon" className="rounded-full shrink-0" data-testid="coop-chat-send"><Send className="w-4 h-4" /></Button>
      </form>
    </div>
  );
}
